// import React, { useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import { blogData } from "../Blog/BlogData"; 
// import {
//   Calendar,
//   User,
//   Facebook,
//   Twitter,
//   Linkedin,
//   ArrowLeft,
//   Scale,
//   MessageSquare,
// } from "lucide-react";
// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";
// import { Helmet } from "react-helmet";

// // COLORS declared at the top as requested
// const COLORS = {
//   bgPrimary: "#0B1C2D",   // Deep Navy
//   bgSecondary: "#13293D", // Slightly Lighter Navy
//   gold: "#C6A75E",        // Premium Gold
//   textLight: "#EAEAEA",
// };

// const BlogDetails = () => {
//   const { blogId } = useParams();
//   const blog = blogData.find((b) => b.id === blogId);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [blogId]);

//   if (!blog) {
//     return (
//       <div className="py-40 text-center font-serif" style={{ backgroundColor: COLORS.bgPrimary, color: COLORS.textLight }}>
//         <h2 className="text-3xl mb-4">Article Not Found</h2>
//         <Link to="/blogs" style={{ color: COLORS.gold }} className="underline">
//           Back to Insights
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>{blog.title} | Advocate Saurav Dagar Advocates & Solicitors</title>
//         <meta name="description" content={blog.excerpt} />
//         <meta name="author" content={blog.author} />
//         <meta property="og:title" content={blog.title} />
//         <meta property="og:image" content={blog.image} />
//       </Helmet>
      
//       <Header />

//       <div className="pt-32 pb-20 overflow-hidden min-h-screen" style={{ backgroundColor: COLORS.bgPrimary }}>
//         <div className="max-w-7xl mx-auto px-6">
          
//           {/* Back Navigation */}
//           <Link
//             to="/blogs"
//             className="group inline-flex items-center gap-2 mb-10 font-sans uppercase text-[10px] font-bold tracking-[3px] transition-all"
//             style={{ color: COLORS.gold }}
//           >
//             <ArrowLeft size={16} className="group-hover:-translate-x-2 transition-transform" />
//             Back to Legal Insights
//           </Link>

//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
//             {/* LEFT COLUMN: Main Article */}
//             <div className="lg:col-span-8">
//               <header className="mb-12">
//                 <div className="flex items-center gap-3 mb-6">
//                   <span 
//                     className="px-4 py-1.5 text-[10px] font-bold uppercase tracking-[3px]"
//                     style={{ backgroundColor: COLORS.gold, color: COLORS.bgPrimary }}
//                   >
//                     {blog.category}
//                   </span>
//                   <div className="h-[1px] w-12 opacity-30" style={{ backgroundColor: COLORS.gold }}></div>
//                 </div>

//                 <h1 className="text-white text-4xl md:text-6xl font-bold leading-[1.1] mb-10">
//                   {blog.title}
//                 </h1>

//                 <div className="flex flex-wrap items-center gap-8 text-gray-400 text-[11px] border-y border-white/10 py-8 font-sans uppercase tracking-[2px]">
//                   <span className="flex items-center gap-2">
//                     <Calendar size={14} style={{ color: COLORS.gold }} /> {blog.date}
//                   </span>
//                   <span className="flex items-center gap-2 text-white font-bold">
//                     <User size={14} style={{ color: COLORS.gold }} /> By {blog.author}
//                   </span>
//                 </div>
//               </header>

//               {/* Featured Image with Premium Border Detail */}
//               <div className="relative mb-16">
//                 <div 
//                     className="absolute inset-0 border-[1px] translate-x-4 translate-y-4 -z-10 opacity-20"
//                     style={{ borderColor: COLORS.gold }}
//                 ></div>
//                 <img
//                   src={blog.image}
//                   alt={blog.title}
//                   className="w-full h-[550px] object-cover rounded-xl shadow-2xl"
//                 />
//                 <div className="absolute -bottom-10 -right-10 hidden md:block opacity-5">
//                   <Scale size={200} color={COLORS.gold} />
//                 </div>
//               </div>

//               {/* Article Content */}
//               <div className="legal-journal-content-container">
//                 <div
//                   className="article-body-text text-gray-300"
//                   dangerouslySetInnerHTML={{ __html: blog.content }}
//                 />
//               </div>

//               {/* Social Share */}
//               <div className="mt-24 pt-10 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-8">
//                 <div>
//                   <p className="text-white text-xl font-bold mb-2">Advocate Saurav Dagar Advocates</p>
//                   <p className="text-[10px] text-gray-500 uppercase tracking-[2px]">Ensuring Justice Through Expertise</p>
//                 </div>
//                 <div className="flex gap-6">
//                   {[Facebook, Twitter, Linkedin].map((Icon, idx) => (
//                       <Icon key={idx} size={20} className="text-gray-400 hover:text-white transition-all cursor-pointer" />
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* RIGHT COLUMN: Sidebar */}
//             <div className="lg:col-span-4">
//               <div className="sticky top-32 space-y-8">
                
//                 {/* Consultation Card */}
//                 <div 
//                     className="p-10 text-white rounded-2xl shadow-2xl overflow-hidden relative border border-white/5"
//                     style={{ backgroundColor: COLORS.bgSecondary }}
//                 >
//                   <div 
//                     className="absolute top-0 right-0 w-32 h-32 rounded-full -mr-16 -mt-16 opacity-10"
//                     style={{ backgroundColor: COLORS.gold }}
//                   ></div>

//                   <h3 className="text-2xl font-bold mb-6 border-b pb-4 relative z-10" style={{ color: COLORS.gold, borderColor: "rgba(206, 167, 94, 0.2)" }}>
//                     Legal Assistance
//                   </h3>
//                   <p className="text-sm text-gray-400 font-sans mb-10 leading-[1.8] italic relative z-10">
//                     "The law is a profession of words; we ensure your words carry the weight of justice."
//                   </p>

//                   <Link to="/contact-us" className="relative z-10 block">
//                     <button 
//                         className="w-full bg-transparent border-2 font-bold py-5 uppercase text-[10px] tracking-[4px] transition-all duration-500 rounded-xl hover:text-white"
//                         style={{ borderColor: COLORS.gold, color:"#fff" }}
//                         onMouseEnter={(e) => e.target.style.backgroundColor = COLORS.gold}
//                         onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
//                     >
//                       Request Consultation
//                     </button>
//                   </Link>

//                   <div className="mt-12 pt-8 border-t border-white/5 flex flex-col gap-4 text-[11px] font-sans tracking-[1px] text-gray-500">
//                     <p className="flex items-center gap-2"><MessageSquare size={14} style={{ color: COLORS.gold }} /> Confidential Advisory</p>
//                     <p>📍 Saket Court, New Delhi</p>
//                   </div>
//                 </div>

//                 {/* Topics Cloud */}
//                 <div className="p-8 rounded-2xl border border-white/5" style={{ backgroundColor: COLORS.bgSecondary }}>
//                   <h4 className="font-bold text-white mb-6 text-xs uppercase tracking-widest">
//                     Legal Topics
//                   </h4>
//                   <div className="flex flex-wrap gap-2">
//                     {["Family Law", "Criminal Law", "Bail", "Divorce", "RERA"].map((tag) => (
//                       <span
//                         key={tag}
//                         className="text-[9px] border px-4 py-2 uppercase text-gray-400 hover:text-white cursor-pointer transition-all rounded-full"
//                         style={{ borderColor: "rgba(255,255,255,0.1)" }}
//                       >
//                         {tag}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Journal Styling */}
//         <style dangerouslySetInnerHTML={{ __html: `
//             .article-body-text {
//               font-family: 'Inter', sans-serif;
//               line-height: 2;
//               font-size: 1.125rem;
//             }
//             .article-body-text p {
//               margin-bottom: 2rem;
//               opacity: 0.85;
//             }
//             .article-body-text h2 {
//               font-size: 2.5rem;
//               color: white;
//               font-weight: 700;
//               margin: 4rem 0 1.5rem;
//               border-left: 4px solid ${COLORS.gold};
//               padding-left: 20px;
//             }
//             .article-body-text strong {
//               color: ${COLORS.gold};
//               font-weight: 700;
//             }
//             .article-body-text blockquote {
//               margin: 3rem 0;
//               padding: 2.5rem;
//               background: ${COLORS.bgSecondary};
//               border-radius: 1rem;
//               border-left: 4px solid ${COLORS.gold};
//               font-style: italic;
//               font-size: 1.4rem;
//               color: white;
//             }
//             .article-body-text ul {
//               margin-bottom: 2rem;
//             }
//             .article-body-text li {
//               position: relative;
//               padding-left: 1.5rem;
//               margin-bottom: 1rem;
//               list-style: none;
//             }
//             .article-body-text li::before {
//               content: "";
//               position: absolute;
//               left: 0;
//               top: 12px;
//               width: 8px;
//               height: 2px;
//               background: ${COLORS.gold};
//             }
//         `}} />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default BlogDetails;







import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { blogData } from "../Blog/BlogData"; 
import {
  Calendar,
  User,
  Facebook,
  Twitter,
  Linkedin,
  ArrowLeft,
  MessageSquare,
  Bookmark,
  Share2,
  Clock,
  ChevronRight
} from "lucide-react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Helmet } from "react-helmet";

const COLORS = {
  bgPrimary: "#FAF9F6", 
  gold: "#B68D40",
  textMain: "#1A1A1A",
};

const BlogDetails = () => {
  const { blogId } = useParams();
  const blog = blogData.find((b) => b.id === blogId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blogId]);

  if (!blog) {
    return (
      <div className="py-40 text-center font-serif bg-[#FAF9F6] text-[#1A1A1A]">
        <h2 className="text-4xl mb-6 italic font-light">Article Missing from Archive</h2>
        <Link to="/blogs" className="text-[#B68D40] uppercase tracking-[0.3em] text-[10px] font-black border-b-2 border-[#B68D40] pb-1 hover:text-black hover:border-black transition-all">
          Return to Insights
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{blog.title} | Adv. Saurav Dagar </title>
        <meta name="description" content={blog.excerpt} />
      </Helmet>
      
      <Header />

      <div className="pt-40 pb-32 min-h-screen selection:bg-[#B68D40] selection:text-white" style={{ backgroundColor: COLORS.bgPrimary }}>
        <div className="max-w-7xl mx-auto px-6">
          
          {/* 1. EDITORIAL BREADCRUMBS */}
          <nav className="flex items-center gap-3 mb-16 text-[10px] uppercase tracking-[0.2em] font-bold text-gray-400">
            <Link to="/" className="hover:text-[#B68D40] transition-colors">Home</Link>
            <ChevronRight size={10} />
            <Link to="/blogs" className="hover:text-[#B68D40] transition-colors">Legal Archive</Link>
            <ChevronRight size={10} />
            <span className="text-[#1A1A1A] truncate max-w-[200px]">{blog.title}</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-20">
            
            {/* 2. MAIN CONTENT AREA */}
            <div className="lg:col-span-8">
              <header className="mb-16">
                <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full border border-[#B68D40]/20 bg-[#B68D40]/5 text-[#B68D40] text-[9px] font-black uppercase tracking-[0.3em] mb-8">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#B68D40] opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-[#B68D40]"></span>
                  </span>
                  {blog.category}
                </div>

                <h1 className="text-[#1A1A1A] text-5xl md:text-7xl font-serif font-light leading-[1.1] mb-10 tracking-tight">
                  {blog.title}
                </h1>

                <div className="flex flex-wrap items-center gap-10 py-8 border-y border-gray-200/60">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden border border-gray-100">
                         <img src="https://api.dicebear.com/7.x/initials/svg?seed=SKS" alt="Author" />
                    </div>
                    <div>
                        <p className="text-[9px] uppercase tracking-widest text-gray-400 font-bold">Written By</p>
                        <p className="text-xs font-bold text-[#1A1A1A]">{blog.author}</p>
                    </div>
                  </div>
                  <div className="h-8 w-px bg-gray-200 hidden md:block"></div>
                  <div className="flex items-center gap-3 text-gray-500 uppercase tracking-widest text-[10px] font-medium">
                    <Calendar size={14} className="text-[#B68D40]" /> {blog.date}
                  </div>
                  <div className="flex items-center gap-3 text-gray-500 uppercase tracking-widest text-[10px] font-medium">
                    <Clock size={14} className="text-[#B68D40]" /> 8 Min Read
                  </div>
                </div>
              </header>

              {/* HIGH-END FEATURE IMAGE */}
              <div className="relative mb-20 group">
                <div className="absolute inset-0 bg-[#B68D40] rounded-[2rem] rotate-1 scale-95 opacity-10 group-hover:rotate-0 transition-transform duration-700"></div>
                <div className="relative overflow-hidden rounded-[2rem] shadow-2xl">
                    <img
                        src={blog.image}
                        alt={blog.title}
                        className="w-full h-[550px] object-cover hover:scale-105 transition-transform duration-1000"
                    />
                </div>
              </div>

              {/* ARTICLE BODY */}
              <article className="legal-journal-content-container relative">
                {/* Vertical Social Bar */}
                <div className="hidden xl:flex flex-col gap-6 absolute -left-20 top-0">
                    <button className="w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center hover:text-[#B68D40] hover:border-[#B68D40] transition-all shadow-sm">
                        <Facebook size={16} />
                    </button>
                    <button className="w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center hover:text-[#B68D40] hover:border-[#B68D40] transition-all shadow-sm">
                        <Twitter size={16} />
                    </button>
                    <button className="w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center hover:text-[#B68D40] hover:border-[#B68D40] transition-all shadow-sm">
                        <Linkedin size={16} />
                    </button>
                </div>

                <div
                  className="article-body-text text-[#333333] drop-cap"
                  dangerouslySetInnerHTML={{ __html: blog.content }}
                />
              </article>

              {/* AUTHOR SIGN-OFF */}
              <div className="mt-24 p-12 bg-white rounded-[2.5rem] border border-gray-100/50 shadow-sm flex flex-col md:flex-row items-center justify-between gap-8 group">
                <div className="text-center md:text-left">
                  <p className="text-[10px] text-[#B68D40] uppercase tracking-[0.4em] font-black mb-3">Principal Solicitor</p>
                  <h4 className="text-[#1A1A1A] text-2xl font-serif font-light italic leading-none group-hover:text-[#B68D40] transition-colors">Adv. Saurav Dagar  </h4>
                </div>
                <div className="flex gap-4">
                  <button className="px-8 py-4 bg-[#FAF9F6] border border-gray-100 rounded-xl uppercase text-[10px] tracking-widest font-black flex items-center gap-3 hover:bg-black hover:text-white transition-all">
                    <Share2 size={14} /> Share Insight
                  </button>
                </div>
              </div>
            </div>

            {/* 3. SIDEBAR */}
            <div className="lg:col-span-4">
              <div className="sticky top-40 space-y-8">
                
                {/* BOOKMARK / ACTIONS */}
                <div className="flex gap-4 mb-8">
                    <button className="flex-1 bg-white py-4 rounded-2xl border border-gray-100 flex items-center justify-center gap-2 text-[10px] font-bold uppercase tracking-widest hover:border-[#B68D40] transition-all">
                        <Bookmark size={14} className="text-[#B68D40]" /> Save Article
                    </button>
                </div>

                {/* ADVOCATE CONTACT CARD */}
                <div className="bg-[#1A1A1A] p-10 rounded-[2.5rem] shadow-2xl relative overflow-hidden group">
                  <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-[#B68D40] rounded-full opacity-10 group-hover:scale-150 transition-transform duration-1000"></div>
                  
                  <h3 className="text-xl font-serif text-white mb-6 leading-tight font-light">
                    Seeking specialized <br /><span className="text-[#B68D40] italic">legal representation?</span>
                  </h3>
                  
                  <Link to="/contact-us">
                    <button 
                        className="w-full bg-[#B68D40] text-white font-black py-5 uppercase text-[10px] tracking-[0.3em] transition-all duration-500 rounded-2xl hover:bg-white hover:text-black"
                    >
                      Request Consultation
                    </button>
                  </Link>

                  <div className="mt-10 space-y-4">
                    <div className="flex items-center gap-3 text-[9px] font-bold text-gray-400 uppercase tracking-widest">
                        <div className="w-1 h-1 rounded-full bg-[#B68D40]"></div>
                        Response within 24 hours
                    </div>
                    <div className="flex items-center gap-3 text-[9px] font-bold text-gray-400 uppercase tracking-widest">
                        <div className="w-1 h-1 rounded-full bg-[#B68D40]"></div>
                        Strict Confidentiality
                    </div>
                  </div>
                </div>

                {/* PRACTICE TAGS */}
                <div className="p-10 bg-white rounded-[2.5rem] border border-gray-100 shadow-sm">
                  <h4 className="text-[10px] font-black text-[#1A1A1A] mb-8 uppercase tracking-[0.4em] border-b border-gray-50 pb-4">
                    Expertise
                  </h4>
                  <div className="flex flex-wrap gap-3">
                    {["Family Law", "Criminal Defense", "Bail Jurisprudence", "Real Estate", "Litigation"].map((tag) => (
                      <span
                        key={tag}
                        className="text-[9px] bg-[#FAF9F6] border border-gray-100 px-5 py-2.5 uppercase text-gray-500 font-bold hover:text-white hover:bg-[#B68D40] hover:border-[#B68D40] cursor-pointer transition-all rounded-lg"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* REFINED JOURNAL STYLING */}
        <style dangerouslySetInnerHTML={{ __html: `
            .article-body-text {
              font-family: 'Inter', sans-serif;
              line-height: 2.2;
              font-size: 1.2rem;
              letter-spacing: -0.01em;
            }
            .article-body-text p {
              margin-bottom: 2.5rem;
              color: #333;
              font-weight: 400;
            }
            .article-body-text.drop-cap p:first-of-type::first-letter {
              float: left;
              font-family: 'Playfair Display', serif;
              font-size: 5rem;
              line-height: 4rem;
              padding-top: 4px;
              padding-right: 12px;
              padding-left: 3px;
              color: ${COLORS.gold};
              font-weight: 300;
            }
            .article-body-text h2 {
              font-family: 'Playfair Display', serif;
              font-size: 2.8rem;
              color: #1A1A1A;
              font-weight: 400;
              line-height: 1.2;
              margin: 5rem 0 2rem;
            }
            .article-body-text blockquote {
              margin: 5rem 0;
              padding: 4rem;
              background: white;
              border-radius: 2.5rem;
              font-family: 'Playfair Display', serif;
              font-style: italic;
              font-size: 1.8rem;
              line-height: 1.5;
              color: #1A1A1A;
              text-align: center;
              border: 1px solid rgba(182, 141, 64, 0.1);
              box-shadow: 0 20px 40px rgba(0,0,0,0.02);
              position: relative;
            }
            .article-body-text blockquote::before {
                content: '"';
                position: absolute;
                top: -20px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 6rem;
                color: ${COLORS.gold};
                opacity: 0.2;
            }
            .article-body-text strong {
              color: #000;
              font-weight: 800;
            }
            .article-body-text ul {
              margin: 3rem 0;
              background: #fff;
              padding: 3rem;
              border-radius: 2rem;
              border: 1px solid #eee;
            }
            .article-body-text li {
              position: relative;
              padding-left: 2.5rem;
              margin-bottom: 1.5rem;
              list-style: none;
              color: #444;
              font-size: 1.1rem;
            }
            .article-body-text li::before {
              content: "";
              position: absolute;
              left: 0;
              top: 12px;
              width: 12px;
              height: 2px;
              background: ${COLORS.gold};
            }
        `}} />
      </div>

      <Footer />
    </>
  );
};

export default BlogDetails;